<div class="special-constraint">
    @for (item of data(); track item) {
    <div class="special-constraint__item">
        <div class="special-constraint__column--left">
            <span class="special-constraint__item__title">
                <div>{{ item.constraint.name.toLowerCase() | capitalize : true }}</div>
                <div class="counter-wrapper">
                    <div class="counter">{{ item.count }}</div>
                </div>
            </span>
        </div>
        <div class="special-constraint__column--right">
            <span class="special-constraint__item__rangebar__title">Antatt påvirkningsgrad</span>
            <div class="special-constraint__item__rangebar">
                <ev-rangebar [highlighted]="item.constraint.warningLevel"></ev-rangebar>
            </div>
        </div>
    </div>
    } @if (data() && data().length > 0) {
    <div class="special-constraint__description">
        <p class="special-constraint__description__paragraph">Vi har identifisert forhold ved eiendommen som kan påvirke eiendommens markedsverdi negativt.</p>
        @if (!hideLandRegUrl()) {
        <p class="special-constraint__description__paragraph">
            @switch (registeredType()) { @case (judicialTypes.Judicial) {
            <span>
                @if (url() !== "" && canSeeLink) { Se <a [href]="url()" target="_blank" class="special-constraint__description__link">Grunnboksutskrift</a> for
                en oversikt over alle servitutter. } @else { Se Grunnboksutskrift for en oversikt over alle servitutter. }
            </span>
            } @case (judicialTypes.Mixed) {
            <span>
                @if (url() !== "" && canSeeLink) { Se <a [href]="url()" target="_blank" class="special-constraint__description__link">Grunnboksutskrift</a> for
                en oversikt over tinglyste servitutter } @else { Se Grunnboksutskrift for en oversikt over tinglyste servitutter }
            </span>
            } }
        </p>
        }
    </div>
    }
</div>
